module.exports = __webpack_public_path__ + "img/risk-panel-info.1daa1313.png";